import Shepherd from "shepherd.js";
import { tourChecker, addTourToQueue } from "@/lib/tour";

export const startTour = ({ check = true, options = {} } = {}) => {
  const tourName = "LayerCreation";
  // console.warn("Started Tour of ", tourName);

  // If tour has been shown before and check is true, don't show it.
  if (check && tourChecker(tourName)) return;

  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    exitOnEsc: true,
    tourName,
    ...options,
  });

  tour.addStep({
    text: "This is console creation, let's take a tour",
    buttons: [
      {
        text: "Skip",
        secondary: true,
        action: tour.complete,
      },
      {
        text: "Start the tour",
        action: tour.next,
      },
    ],
  });

  /**
   * City Selection Tour
   */
  tour.addSteps([
    {
      attachTo: {
        element: ".search-modal-wrapper .search-input",
        on: "bottom",
      },
      popperOptions: {
        modifiers: [{ name: "offset", options: { offset: [15, 15] } }],
      },
      text: "Let's start be searching for a city.",
      buttons: [
        {
          text: "Skip",
          secondary: true,
          action: tour.complete,
        },
        {
          text: "NEXT: Select a City",
          action: tour.next,
        },
      ],
    },
    {
      attachTo: {
        element: ".suggestions-wrapper",
        on: "bottom",
      },
      popperOptions: {
        modifiers: [{ name: "offset", options: { offset: [15, 15] } }],
      },
      advanceOn: {
        selector: ".suggestions-wrapper",
        // selector: ".city-item",
        event: "click",
      },
      text: "Now Choose a City",
      buttons: [
        {
          text: "Skip",
          secondary: true,
          action: tour.complete,
        },
        {
          text: "Back",
          secondary: true,
          action: tour.back,
        },
      ],
    },
  ]);

  /**
   * Layer Creation Tour
   */
  tour.addSteps([
    {
      attachTo: { element: ".add-new-layer-card", on: "right" },
      popperOptions: {
        modifiers: [{ name: "offset", options: { offset: [15, 15] } }],
      },
      advanceOn: { selector: ".add-new-layer-card", event: "click" },
      text: "Let's create the first Layer",
    },
    // {
    //   attachTo: {
    //     element: ".create-new-layer-popup .layer-list-item",
    //     on: "right",
    //   },
    //   popperOptions: {
    //     modifiers: [{ name: "offset", options: { offset: [15, 15] } }],
    //   },
    //   // attachTo: {
    //   //   element: ".layer-popup .popup-options li:first-child",
    //   //   on: "right",
    //   // },
    //   advanceOn: {
    //     selector: ".create-new-layer-popup .layer-list-item",
    //     event: "click",
    //   },
    //   text: "Select 'New Entity Layer' to plot an entity.",
    //   buttons: [
    //     {
    //       text: "Skip",
    //       action: tour.complete,
    //     },
    //   ],
    // },
    // {
    //   attachTo: {
    //     element: ".create-new-layer-popup .entity-list .flex-col",
    //     on: "right",
    //   },
    //   popperOptions: {
    //     modifiers: [{ name: "offset", options: { offset: [15, 15] } }],
    //   },
    //   advanceOn: {
    //     selector: ".create-new-layer-popup .entity-list .flex-col",
    //     event: "click",
    //   },
    //   text: "Select an Entity",
    //   buttons: [
    //     // {
    //     //   text: "Done",
    //     //   action: tour.next,
    //     // },
    //     {
    //       text: "Skip",
    //       action: tour.complete,
    //     },
    //   ],
    // },
    // {
    //   attachTo: {
    //     element: ".create-new-layer-popup .entity-config",
    //     on: "right",
    //   },
    //   popperOptions: {
    //     modifiers: [{ name: "offset", options: { offset: [15, 15] } }],
    //   },
    //   advanceOn: {
    //     selector: ".create-new-layer-popup .entity-config",
    //     event: "click",
    //   },
    //   text: "Give an Entity Name",
    //   buttons: [
    //     {
    //       text: "Done",
    //       action: tour.next,
    //     },
    //   ],
    // },
  ]);

  addTourToQueue(tour, tourName);
};
